"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Golf = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Golf, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Golf);

  function Golf() {
    (0, _classCallCheck2["default"])(this, Golf);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Golf, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M19.5,21 C18.6715729,21 18,20.3284271 18,19.5 C18,18.6715729 18.6715729,18 19.5,18 C20.3284271,18 21,18.6715729 21,19.5 C21,20.3284271 20.3284271,21 19.5,21 Z M11,18.03 C13.84,18.19 16,19.01 16,20 C16,21.1 13.31,22 10,22 C6.69,22 4,21.1 4,20 C4,19.26 5.21,18.62 7,18.27 L7,19 C7,19.55 7.45,20 8,20 C8.55,20 9,19.55 9,19 L9,3.6 C9,2.86 9.78,2.38 10.45,2.71 L15.21,5.04 C15.95,5.4 15.95,6.46 15.22,6.83 L11,8.98 L11,18.03 Z"
      }));
    }
  }]);
  return Golf;
}(_react["default"].PureComponent);

var _default = Golf;
exports["default"] = _default;